import { useSelector } from 'react-redux';

import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';

/**
 * Usuário que acessa a plataforma exclusivamente para contratar Seguro Garantia.
 * Fonte única da flag — nenhum componente deve ler `is_only_conlicitaseg` direto do store.
 */
function useOnlyConlicitaseg(): boolean {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return !!profile?.is_only_conlicitaseg;
}

export default useOnlyConlicitaseg;
